import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  container({ container_id }) {
    return RequesterV1.get(
      `packing_house/production/uniq_final_packing_list/new_packages/container/${container_id}`
    );
  },
  fetchPackingHouseProcess({packing_house_process_id}) {
    return RequesterV1.get(
      "packing_house/production/uniq_final_packing_list/new_packages/fetch_packing_house_process/" + packing_house_process_id
    );
  },
  createPackages(container_id, packages) {
    return RequesterV1.post(
      `packing_house/production/uniq_final_packing_list/new_packages/container/${container_id}/create/`,
      { packages: packages }
    );
  },
  fetchExportProcessCropCategories(container_id) {
    return RequesterV1.get(
      "packing_house/production/uniq_final_packing_list/new_packages/list_exporter_process_crop_categories/" +
       container_id 
    );
  },
  fetchExportProcessCropVarieties(container_id) {
    return RequesterV1.get(
      "packing_house/production/uniq_final_packing_list/new_packages/list_exporter_process_crop_varieties/" +
       container_id 
    );
  },
  fetchExportProcessCropSizes(container_id) {
    return RequesterV1.get(
      "packing_house/production/uniq_final_packing_list/new_packages/list_exporter_process_crop_sizes/" +
       container_id 
    );
  },
  fetchExportProcessBrands(container_id) {
    return RequesterV1.get(
      `packing_house/production/uniq_final_packing_list/new_packages/list_exporter_process_brands/${container_id}`
    );
  },
  fetchExportProcessCropPackages(container_id) {
    return RequesterV1.get(
      "packing_house/production/uniq_final_packing_list/show_container/list_exporter_process_crop_packages/" +
       container_id 
    );
  },
  fetchPackageGroups(container_id) {
    return RequesterV1.get(
      "packing_house/production/uniq_final_packing_list/new_packages/list_package_groups/" +
        container_id
    );
  },
  fetchProducersOrganizations(container_id) {
    return RequesterV1.get(
      "packing_house/production/uniq_final_packing_list/new_packages/fetch_producers_organizations/" +
       container_id 
    );
  }
};
